import { useState } from 'react';
import { yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { useBidRange } from './useBidRange';
import { useOrderStore } from 'store/orderStore';
import { useCampaignStore } from 'store/campaignStore';
import { getBasicValidationSchema } from './validationSchemas';
// import { ActionType, SelectPattern } from 'core/rtbCampaign/singlePage/common';

interface initialKeywords {
  defaultForm: any;
  newForm: any;
}

const useRecommendValidation = (
  initialState: initialKeywords = { defaultForm: {}, newForm: {} },
) => {
  const { defaultForm, newForm } = initialState;
  const { order } = useOrderStore();
  const { actionType } = useCampaignStore();
  const bidRange = useBidRange();
  const [errors, setErrors] = useState<any>({ basic: {}, products: '' });

  const commonSchema = getBasicValidationSchema({
    defaultForm,
    actionType,
    order,
    bidRange,
  });

  const recommendBasicSchema = Yup.object()
    .shape({
      selectPattern: Yup.string().required('這裡還是空白的哦！'),
    })
    .concat(commonSchema);

  const validationSchema = Yup.object().shape({
    basic: recommendBasicSchema,
    // products: Yup.array().when('basic.selectPattern', {
    //   is: (selectPattern) => selectPattern === SelectPattern.MANUAL,
    //   then: (schema) =>
    //     schema
    //       .min(5, '需選擇5項以上商品，以利系統優化投放成效')
    //       .max(50, '已超過選品上限50品，請重新調整選品'),
    // }),
    // autoProducts: Yup.array().when('basic.selectPattern', {
    //   is: (selectPattern) =>
    //     selectPattern === SelectPattern.AUTO &&
    //     (actionType === ActionType.CREATE || actionType === ActionType.COPY),
    //   then: (schema) =>
    //     schema
    //       .min(5, '此品牌下商品未符合推薦智能選品條件，請選擇其他品牌')
    //       .max(50, '已超過選品上限50品，請選擇其他品牌'),
    // }),
  });

  const handleValidation = () => {
    validationSchema
      .validate(newForm, { abortEarly: false })
      .then(() => setErrors({}))
      .catch((err) => {
        setErrors(yupToFormErrors(err));
      });
  };

  return { validationSchema, errors, setErrors, handleValidation };
};

export default useRecommendValidation;
